// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Me2O","head":"Table_head__2DkNu","col":"Table_col__2PnIf"};